import {
  Grid,
  Typography,
  CardContent,
  Card,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
} from "react-admin";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import FormField from "../../../components/Common/FormField";

function InfoProjectTab() {
  const { t }: { t: any } = useTranslation();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box pb={2}>
          <Typography variant="h6">{t("Entity details")}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t("The entity's name, account, type and status")}
          </Typography>
        </Box>
        <AnimatedBlock>
          <Card>
            <CardContent
              sx={{
                p: 4,
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormField label={t("Name")}>
                    <TextInput
                      source="name"
                      label={t("Name")}
                      fullWidth
                    />
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t("Account")}>
                    <ReferenceInput source="accountId" reference="accounts">
                      <AutocompleteInput label={t("Account")} fullWidth />
                    </ReferenceInput>
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t("Type")}>
                    <SelectInput fullWidth
                      source="typeProject"
                      label={t("Type")}
                      choices={[
                        { id: "gasStation", name: "Gas station" },
                        { id: "cryptoPayment", name: "Crypto payment" },
                        //{ id: 'cardPayment', name: 'Card Payment' },
                      ]}
                    />
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t("Status")}>
                    <SelectInput fullWidth
                      source="status"
                      label={t("Status")}
                      choices={[
                        { id: "active", name: "Active" },
                        { id: "inactive", name: "Inactive" },
                      ]}
                    />
                  </FormField>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </AnimatedBlock>
      </Grid>
    </Grid>
  );
}

export default InfoProjectTab;
